import React from "react";
import styles from "./AppCollectionsModalItem.module.scss";
import { AppCollection } from "@/features/auth/types/auth";

interface AppCollectionsModalItemProps {
  item: AppCollection;
  onItemClick: () => void;
  isActive: boolean;
}

const AppCollectionsModalItem: React.FC<AppCollectionsModalItemProps> = ({
  item,
  onItemClick,
  isActive,
}) => {
  return (
    <div
      className={`${styles.root} ${isActive ? styles.activeItem : ""}`}
      onClick={onItemClick}
    >
      <h4>{item.name}</h4>
      <p>
        ({item.total_apps === 0
          ? `${item.total_apps} Apps`
          : `${item.total_apps > 1 ? `${item.total_apps} Apps` : `${item.total_apps} App`}`})
      </p>
    </div>
  );
};

export default AppCollectionsModalItem;
